import React from "react";
import ScrollToTopButton from "../../../components/UI/ScrollToTopButton";

const TenantFooter: React.FC = () => (
  <>
    <ScrollToTopButton />
    <div className="bg-grey-1 py-64px">
      <div className="w-100 max-w-960px px-30px px-lg-0 mx-auto">
        <div className="fs-16px fw-normal text-white">Copyright &copy; 2025</div>
      </div>
    </div>
  </>
);

export default TenantFooter;
